import { render, staticRenderFns } from "./memoCreate.vue?vue&type=template&id=047302a1&"
import script from "./memoCreate.vue?vue&type=script&lang=js&"
export * from "./memoCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports